exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-creditcardicon-style__icon{display:inline-block;height:30px;line-height:37px;vertical-align:top;width:30px}div.nil-sa-elements-creditcardicon-style__icon img{max-height:16px;max-width:30px}div.nil-sa-elements-creditcardicon-style__icon.nil-sa-elements-creditcardicon-style__discover{line-height:20px}", ""]);

// exports
exports.locals = {
	"icon": "nil-sa-elements-creditcardicon-style__icon",
	"discover": "nil-sa-elements-creditcardicon-style__discover"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/CreditCardIcon/style.less
// module id = 395
// module chunks = 0